<template>
<section class="closefriend-hero settings-page blocked-friends-page">
  <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
  <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
  <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

  <div class="container-fluid mt-3 pb-5">
    <div class="row justify-content-center">
      <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <global-message></global-message>
          
          <div class="mb-4 settings-section p-4 mt-2">
            <!-- Header with Search on Right -->
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
              <div>
                <h5 class="text-white font-weight-700 mb-0 font-size-20">Blocked Fans</h5>
                <span class="text-muted font-size-12">{{ customerSubscriptions.length }} blocked</span>
              </div>
              <div class="position-relative" style="width: 100%; max-width: 250px;">
                <input type="text" class="form-control blocked-search-input text-white" 
                       placeholder="Search Username..." 
                       v-model="searchQuery" 
                       @input="debounceSearch">
              </div>
            </div>
            
            <div v-if="customerSubscriptions.length === 0 && !busy" class="d-flex align-items-center justify-content-center" style="min-height: 200px;">
              <span style="color: rgba(255,255,255,0.4); font-size: 14px;">No blocked fans found</span>
            </div>

            <div v-else class="row w-100 mx-0">
              <div class="col-12 col-md-6 col-lg-4 mb-3 px-2" v-for="(customerSubscription, index) in customerSubscriptions" :key="index">
                <div class="custom-card-transparent" @click="confirmSingleSave(customerSubscription, 'unblock')">
                  <div class="stella-card-header d-flex align-items-center justify-content-between">
                    <span class="stella-card-index">#{{ index + 1 }}</span>
                    <button class="btn btn-sm rounded-pill stella-unblock-btn px-3 py-1" @click.stop="confirmSingleSave(customerSubscription, 'unblock')">Unblock</button>
                  </div>
                  <div class="stella-card-body mt-3">
                    <h6 class="stella-card-title text-white text-truncate font-weight-600 mb-0" :title="customerSubscription.handle">{{ customerSubscription.handle }}</h6>
                  </div>
                  <div class="stella-card-footer mt-4">
                    <div class="font-size-10" style="color: rgba(255, 255, 255, 0.4); text-transform: uppercase; letter-spacing: 0.5px;">
                      Blocked On: <span class="text-white ml-1 font-weight-500">{{customerSubscription.friendSince | formatDate}} {{ customerSubscription.friendSince | formatTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <infinite-loading ref="infiniteLoading"
                    @infinite="loadMobileSubscriptions">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
  </infinite-loading>
  <model ref="model" @confirm="unblock()" @cancel=""/>
</section>
</template>

<script>


import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import {httpMixin} from "@/mixin/http-mixin";
import {geDecodedToken} from "@/common/http-common";
import {ACCESS_TOKEN} from "@/properties/close-friend";
import Model from "@/components/module/shared/Model";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {mapActions} from "vuex";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import InfiniteLoading from "vue-infinite-loading";
import { newSubscriptionMixin } from "@/mixin/new-subscription-mixin";
import { constructCustomerURL } from "@/common/baseURL-service";

export default {
  name: 'BlockedFriendsMobile',
  components: {HeaderMenu, InfluencerMenu, InfluencerHeader, Model, GlobalMessage, PwaActionBar, InfiniteLoading},
  mixins: [httpMixin, newSubscriptionMixin],
  data() {
    return {
      user: {},
      showSlideBar: false,
      pageNumber: 0,
      noOfItems: 30,
      isComplete: false,
      busy: false,
      customerSubscriptions: [],
      searchQuery: '',
      searchTimeout: null
    }
  },
  created() {
  },
  methods: {
    constructCustomerURL,
    ...mapActions(['pushGlobalError', 'setMessage']),
    close() {
      this.$router.replace({name: 'CreatorDashboardMobile'})
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },

    debounceSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      const queryLength = this.searchQuery ? this.searchQuery.trim().length : 0;
      // Only search if empty (reset) or at least 3 characters
      if (queryLength > 0 && queryLength < 3) {
        return;
      }
      
      this.searchTimeout = setTimeout(() => {
        this.pageNumber = 0;
        this.customerSubscriptions = [];
        if (this.$refs.infiniteLoading) {
          this.$refs.infiniteLoading.stateChanger.reset();
        }
      }, 500);
    },
    loadMobileSubscriptions($state) {
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      let url = `subscription/api/v1/influencers/${userId}/status/Blocked/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`;
      if (this.searchQuery && this.searchQuery.trim() !== '') {
        url += `&search=${encodeURIComponent(this.searchQuery.trim())}`;
      }
      this.getData(url, (page) => {
        if (!page.empty) {
          this.customerSubscriptions.push(...page.content);
          this.pageNumber += 1;
          $state.loaded();
        }
        if (page.last) {
          $state.complete();
        }
      });
    },
    loadNonMobileSubscriptions() {
      if (this.isComplete || this.busy) {
        return;
      }
      this.busy = true;
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      this.getData(`subscription/api/v1/influencers/${userId}/status/Blocked/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`, (page) => {
        if (!page.empty) {
          this.customerSubscriptions.push(...page.content);
          this.pageNumber += 1;
          this.isComplete = page.last;
        }
        this.busy = false;
      });
    },

    confirmSingleSave(customerSubscription, action) {
      this.customerSubscription = customerSubscription;
      this.action = action;
      let insert = '@' + (customerSubscription.name ? customerSubscription.name : customerSubscription.email);
      let text = this.getModelText(action, insert);
      this.$refs.model.show(action+'?', text);
    },

    unblock() {
      this.customerSubscription.status = 'Inactive'
      let userId = geDecodedToken(ACCESS_TOKEN).id;
      let url = `subscription/api/v1/influencers/${userId}/status/`;

      this.patchData(url, [this.customerSubscription], (data) => {
        this.pageNumber = 0;
        this.isComplete = false;
        this.customerSubscriptions = [];
        this.$refs.model.hide();
        this.loadNonMobileSubscriptions();
        this.setMessage('Saved successfully');
      });
    },
    getModelText(action, insert) {
        return `Please confirm that ${insert} fans have been ${action} as Close Friend`;
    },
  }
}
;
</script>
<style scoped>
/* ===== PAGE BACKGROUND ===== */


/* ===== SECTION CARDS ===== */
.settings-section {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  overflow: hidden;
  transition: border-color 0.3s ease;
}
.settings-section:hover {
  border-color: rgba(255, 89, 212, 0.3);
}

.settings-section-title {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 12px 20px;
  margin: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

/* ===== SEARCH INPUT ===== */
.blocked-search-input {
  background-color: transparent !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  font-size: 13px !important;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.blocked-search-input:focus {
  background-color: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 89, 212, 0.5) !important;
  color: white !important;
}
.blocked-search-input::placeholder {
  color: rgba(255, 255, 255, 0.3) !important;
}
.blocked-search-input:-webkit-autofill,
.blocked-search-input:-webkit-autofill:hover,
.blocked-search-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #1c1c1c inset !important;
  box-shadow: 0 0 0 1000px #1c1c1c inset !important;
  -webkit-text-fill-color: #ffffff !important;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  transition: background-color 50000s ease-in-out 0s !important;
}

.blocked-search-input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #1c1c1c inset, 0 0 14px rgba(229, 59, 185, 0.35) !important;
  box-shadow: 0 0 0 1000px #1c1c1c inset, 0 0 14px rgba(229, 59, 185, 0.35) !important;
  border-color: #E53BB9 !important;
  -webkit-text-fill-color: #ffffff !important;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  outline: none !important;
  transition: background-color 50000s ease-in-out 0s !important;
}

/* ===== CUSTOM CARDS ===== */



.stella-card-index {
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
  font-weight: 600;
}
.stella-card-status {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
}

.stella-unblock-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  transition: all 0.3s ease;
  padding: 6px 16px;
}
.stella-unblock-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.4);
  color: #ffffff;
}

.text-handle {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}
.text-date {
  color: rgba(255, 255, 255, 0.4);
}

.scroll-list-custom {
  overflow-x: hidden;
}
.scroll-list {
  scrollbar-width: none !important;
}

/* Set the height to 100% of the viewport minus 50px */
.scroll-class {
  height: calc(100vh - 10vh) !important;
}

.scroll-list {
  overflow: auto;
  /*height: 470px;*/
  height: calc(100vh - 10vh) !important;
  /*height: inherit !important;*/
  overflow-x: hidden;
}
.scroll-parent{
  height: 100vh !important;
  /* overflow: hidden; */
  overflow-y: scroll;
  padding: 0px;
  margin: 0px;
  scrollbar-width: none;
}

</style>
